import { render, staticRenderFns } from "./Alarm.vue?vue&type=template&id=21eda30d&scoped=true&lang=pug"
import script from "./Alarm.vue?vue&type=script&lang=js"
export * from "./Alarm.vue?vue&type=script&lang=js"
import style0 from "./Alarm.vue?vue&type=style&index=0&id=21eda30d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eda30d",
  null
  
)

export default component.exports